import { Navigate } from 'react-router-dom';

/**
 * Search is now the same as Home with optional query params.
 * Redirect so /search and /search?type=rent etc. show the home page with filters.
 */
export default function Search() {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const type = params.get('type');
  const location = params.get('location');
  const query = new URLSearchParams();
  if (type) query.set('type', type);
  if (location) query.set('location', location);
  const qs = query.toString();
  return <Navigate to={qs ? `/?${qs}` : '/'} replace />;
}
